import { render, staticRenderFns } from "./UnacknowledgedPositionDescriptionList.vue?vue&type=template&id=7a2df643&scoped=true&"
import script from "./UnacknowledgedPositionDescriptionList.vue?vue&type=script&lang=js&"
export * from "./UnacknowledgedPositionDescriptionList.vue?vue&type=script&lang=js&"
import style0 from "./UnacknowledgedPositionDescriptionList.vue?vue&type=style&index=0&id=7a2df643&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a2df643",
  null
  
)

export default component.exports